import { styled } from "@mui/system";
import Button from "@mui/material/Button";

import NewColors from "../themes/NewColors";

const MenuButtonDeSelected = styled(Button)(() => ({
  color: "black",
  backgroundColor: "white",
  fontWeight: "600",
  justifyContent: "left",
  width: "100%",
  borderRadius: 10,
  "&:hover": {
    backgroundColor: NewColors.sectionBackground,
  },
}));

export default MenuButtonDeSelected;
